import React from 'react';
const galleryImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/9XxAcEyLaUy8HtedVx8wgF/Screenshot_2026-03-06_154818.png',
  alt: 'Carpet cleaning before and after'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/x3xEkjuoYdgV2zfiX2y29a/Screenshot_2026-03-06_154835.png',
  alt: 'Tile and grout cleaning before and after'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qu11shZ1sEFxgRQVLzLFdG/Screenshot_2026-03-06_154847.png',
  alt: 'Carpet stain removal before and after'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5ksB4XecRS37jzQa3KsDCz/Screenshot_2026-03-06_154649.png',
  alt: 'Carpet deep cleaning before and after'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1WH33muLevMFxhNRukukLg/Screenshot_2026-03-06_154751.png',
  alt: 'Concrete floor cleaning before and after'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pLvZAajizyqjFGWfvt5TtM/Screenshot_2026-03-06_154805.png',
  alt: 'Tile floor cleaning before and after'
}];
export function BeforeAfterSection() {
  return <section id="gallery" className="py-16 md:py-24 bg-white" data-id="element-67">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-68">
        <div className="text-center mb-12 md:mb-16" data-id="element-69">
          <h2 className="font-heading text-3xl md:text-4xl font-bold italic text-navy mb-4" data-id="element-70">
            See the Difference
          </h2>
          <p className="text-lg text-silver max-w-2xl mx-auto" data-id="element-71">
            Real results from real Phoenix homes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-72">
          {galleryImages.map((image, index) => <div key={index} className="w-full aspect-[4/3] rounded-lg overflow-hidden shadow-md bg-muted relative group" data-id="element-73">
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover" data-id="element-74" />
            </div>)}
        </div>
      </div>
    </section>;
}